/** @jsx h */
/** @jsxFrag Fragment */
import { h, render } from "preact";
import { ShushMainPage } from "@/spa/main.tsx";

function main() {
  const el = document.getElementById("main");
  if (el) render(<ShushMainPage />, el);
}

main();
